import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ar from './ar/common.json';
import en from './en/common.json';
import ur from './ur/common.json';
void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ur', 'ar'],
    interpolation: { escapeValue: false },
    resources: {
        en: { common: en },
        ur: { common: ur },
        ar: { common: ar },
    },
    defaultNS: 'common',
    ns: ['common'],
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
    },
});
export default i18n;
